

























import { Component, Prop, Vue } from 'vue-property-decorator'
import SeletorDeLojasDoUsuario from '@/components/loja/SeletorDeLojasDoUsuario.vue'
import BotaoDeDrawer from '@/components/ui/BotaoDeDrawer.vue'
import IconesDaTollbarPadroes from '@/components/layout/IconesDaToolbarPadroes.vue'
import { Deposito } from '@/models'

@Component({
	components: {
		BotaoDeDrawer,
		IconesDaTollbarPadroes,
		SeletorDeLojasDoUsuario,
	},
})
export default class ToolbarDeSangria extends Vue {
	@Prop({ type: String, default: '' }) titulo!: string
	depositos: Deposito[] = []
	carregando = true

	get loja() {
		return (this.$route.query.l as string) || null
	}

	set loja(idLoja: string | null) {
		this.$router
			.push({
				name: this.$route.name as string,
				query: {
					l: idLoja,
				},
			})
	}			
}
